import './bootstrap/publicPath';

import ReactDOM from 'react-dom';

import oneObject from '#/bootstrap/oneObject';
import devtoolsApi from '#/dev/devtools';
import { PaywallProvider } from '#/hooks';
import { ConfigProvider } from '#/hooks/useConfig';
import { ignoreError } from '#/service/utils';

import App from './App';
import GlobalState from './components/GlobalState';
import GlobalStyle from './components/GlobalStyle';
import { translations } from './store/translation/translation.store';

// TODO After GlobalState was completely removed, extract all of the providers
//  and the logic for their props from here into a new component.

const config = oneObject.config;

if (process.env.goal === 'local') {
  devtoolsApi.overrideConsole();
  devtoolsApi.setContexts({ config });
}

translations.load(config.i18nextConfig).catch(ignoreError);

ReactDOM.render(
  <ConfigProvider config={config}>
    <PaywallProvider>
      <GlobalState>
        <GlobalStyle />
        <App />
      </GlobalState>
    </PaywallProvider>
  </ConfigProvider>,
  document.getElementById('root')
);
